// @flow
import * as React from 'react';
import {Handle, Position} from 'react-flow-renderer';

const SIZE = 16;
const OFFSET = SIZE / 2;
const dimensions = {
  width: `${SIZE}px`,
  height: `${SIZE}px`,
};
type GeneratorHandleProps = {|
  top?: string,
  translateX?: number,
|};

// A special handle that we use for building sequence diagrams in the
// Diagram generator. Sits at the top of the vertical bar.
export const SequenceDiagramGeneratorHandle = ({
  top,
  translateX,
}: GeneratorHandleProps) => (
  <Handle
    type="source"
    position={Position.Right}
    className="diagram-generator"
    id="auto"
    style={{
      top: top || 'calc(50% - 8px)',
      width: '16px',
      height: '16px',
      background: 'white',
      border: '1px solid black',
      textAlign: 'center',
      transform: `translateX(${translateX || 0}px)`,
    }}
  />
);

export const TopHandles = () => (
  <>
    <Handle
      type="target"
      position={Position.Top}
      id="top"
      style={{...dimensions, left: '50%', top: `-${OFFSET}px`}}
    />
    <Handle
      type="source"
      position={Position.Top}
      id="top"
      style={{...dimensions, left: '50%', top: `-${OFFSET}px`}}
    />
  </>
);

export const BottomHandles = () => (
  <>
    <Handle
      type="source"
      position={Position.Bottom}
      id="bottom"
      style={{...dimensions, left: '50%', bottom: `-${OFFSET}px`}}
    />
    <Handle
      type="target"
      position={Position.Bottom}
      id="bottom"
      style={{...dimensions, left: '50%', bottom: `-${OFFSET}px`}}
    />
  </>
);

export const LeftHandles = () => (
  <>
    <Handle
      type="target"
      id="left"
      position={Position.Left}
      style={{...dimensions, top: '50%', left: `-${OFFSET}px`}}
    />
    <Handle
      type="source"
      position={Position.Left}
      id="left"
      style={{...dimensions, top: '50%', left: `-${OFFSET}px`}}
    />
  </>
);

export const RightHandles = () => (
  <>
    <Handle
      type="target"
      id="right"
      position={Position.Right}
      style={{...dimensions, top: '50%', right: `-${OFFSET}px`}}
    />
    <Handle
      type="source"
      position={Position.Right}
      id="right"
      style={{...dimensions, top: '50%', right: `-${OFFSET}px`}}
    />
  </>
);
